import React from 'react';
import { ConfirmationModal, TestnetBar, Title, useModal } from '@zen-common/components-base';
import { ConfigStore, SettingsStore } from '@zen/common-app-parts';

export default function TestnetBarContainer() {
  const {
    state: {
      settings: { oracleUrl },
    },
    actions,
  } = SettingsStore.useStore();
  const config = ConfigStore.useStore();
  const { show, hide } = useModal();

  const handleSwitchChain = () => {
    show(() => (
      <ConfirmationModal
        dismissOnClickOutside={true}
        showClose={false}
        onCancel={hide}
        onConfirm={() => {
          hide();
          actions.setSetting({ name: 'oracleUrl', value: config.oracleUrl['main'] });
        }}
        title={<Title>Confirm changing Oracle</Title>}
      >
        You are about to switch from {oracleUrl} to {config.oracleUrl['main']}.
      </ConfirmationModal>
    ));
  };
  return <TestnetBar onSwitch={handleSwitchChain} />;
}
